<template>
  <v-dialog v-model="mostrar" max-width="290" fullscreen persistent>
    <v-card :loading="loading">
      <v-toolbar color="blue-grey darken-2" dark>
        <v-toolbar-title>Modificar Oficio entrante</v-toolbar-title>
      </v-toolbar>

      <v-container text-center>
        <v-row wrap>
          <v-col md="2">
            <v-text-field
              label="Número:"
              v-model="numero"
              :outlined="outlined"
              :error-messages="numeroErrors"
              @input="$v.numero.$touch()"
              @blur="$v.numero.$touch()"
            ></v-text-field>
          </v-col>
          <v-col md="6">
            <v-text-field
              label="Asunto:"
              v-model="asunto"
              :outlined="outlined"
              :error-messages="asuntoErrors"
              @input="$v.asunto.$touch()"
              @blur="$v.asunto.$touch()"
            ></v-text-field>
          </v-col>
          <v-col md="2">
            <v-menu
              v-model="fechaPicker"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fechaTexto"
                  :outlined="outlined"
                  label="Fecha:"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fecha"
                locale="es"
                @change="fechaPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col md="2">
            <v-select
              v-model="statusSel"
              :items="statusList"
              item-value="nombre"
              item-text="nombre"
              label="Status:"
              :outlined="outlined"
            />
          </v-col>

          <v-col md="12">Datos del emisor:</v-col>
          <buscarEmisorEntidadComponent
            :tipo="'Entrante'" 
            :entidades="emisorEntidades"
            @seleccionarEntidad="seleccionarEntidad"
          />

          <v-col md="4">
            <v-autocomplete
              auto-select-first
              v-model="emisorEntidad"
              :items="emisorEntidades"
              item-value="_id"
              item-text="nombre"
              label="Entidad:"
              :outlined="outlined"
              @change="cambioEntidad()"
              :filter="customFilter"
            >
             <template v-slot:item="{ item }">
                    <ul style="list-style: none;padding-left: 0;">
                        <li >{{ item.nombre }}</li>
                        <li style="font-size: small;color: gray;" >{{ item.cargo }} - {{ item.responsable }}</li>
                    </ul>
                </template>
            </v-autocomplete>
            
          </v-col>
          <v-col md="4">
            <v-text-field
              label="Emisor:"
              v-model="emisorResponsable"
              :outlined="outlined"
              readonly
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <v-text-field
              label="Cargo:"
              v-model="emisorCargo"
              :outlined="outlined"
              readonly
            ></v-text-field>
          </v-col>

          <v-col md="12">Datos del destinatario:</v-col>

          <v-col md="4">
            <v-autocomplete
              auto-select-first
              v-model="dependenciaSel"
              :items="dependencias"
              item-value="_id"
              item-text="nombre"
              label="Dependencia:"
              :outlined="outlined"
              @change="cambioDependencia()"
              :filter="customFilter"
            />
          </v-col>
          <v-col md="4">
            <v-select
              label="Destinatario:"
              v-model="destinatarioSel"
              :items="destinatarios"
              :outlined="outlined"
              item-value="_id"
              item-text="nombre"
              @change="cambioDestinatario()"
            ></v-select>
          </v-col>
          <v-col md="4">
            <v-text-field
              label="Cargo:"
              v-model="destinatarioCargo"
              :outlined="outlined"
              readonly
            ></v-text-field>
          </v-col>

          <v-col md="12">Datos del oficio:</v-col>

          <v-col md="3">
            <v-select
              v-model="tipoSel"
              :items="tipos"
              :outlined="outlined"
              label="Tipo:"
              item-text="nombre"
              item-value="nombre"
            />
          </v-col>
          <v-col md="2">
            <v-text-field
              label="Documentos:"
              v-model="documentos"
              :outlined="outlined"
              :error-messages="documentosErrors"
              @input="$v.documentos.$touch()"
              @blur="$v.documentos.$touch()"
            ></v-text-field>
          </v-col>
          <v-col md="3">
            <v-menu
              v-model="fechaRecepcionPicker"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fechaRecepcionTexto"
                  :outlined="outlined"
                  label="Fecha recepción:"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaRecepcion"
                locale="es"
                @change="fechaRecepcionPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="2">
            <v-menu
              ref="menu"
              v-model="horaRecepcionPicker"
              :close-on-content-click="false"
              :return-value.sync="horaRecepcion"
              max-width="1px"
              min-width="1px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="horaRecepcion"
                  label="Hora recepción"
                  type="time"
                  v-on="on"
                  @change="$refs.menu.save(horaRecepcion)"
                ></v-text-field>
              </template>
            </v-menu>
          </v-col>
          <v-col md="2">
            <v-select
              v-model="original"
              :items="[
                { value: true, text: 'Original' },
                { value: false, text: 'Copia' },
              ]"
              :outlined="outlined"
            ></v-select>
          </v-col>
          <v-col md="4">
            <v-select
              label="Recibió:"
              v-model="recibioUserSel"
              :items="recibioUsers"
              :outlined="outlined"
              item-value="_id"
              item-text="nombreCompleto"
            ></v-select>
          </v-col>
          <v-col md="4">
            <v-autocomplete
              auto-select-first
              v-model="asignacion"
              :items="dependencias"
              item-value="_id"
              item-text="nombre"
              label="Asignar a:"
              :outlined="outlined"
              :filter="customFilter"
            />
          </v-col>
          <v-col md="2">
            <v-select
              v-model="requiereRespuesta"
              label="Requiere respuesta:"
              :items="[
                { value: true, text: 'Si' },
                { value: false, text: 'No' },
              ]"
              :outlined="outlined"
            ></v-select>
          </v-col>
          <v-col md="2">
            <v-menu
              v-model="fechaRespuestaPicker"
              :close-on-content-click="false"
              max-width="290"
              :disabled="!requiereRespuesta"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fechaRespuestaTexto"
                  :outlined="outlined"
                  label="Fecha límite:"
                  readonly
                  v-on="on"
                  :disabled="!requiereRespuesta"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fechaRespuesta"
                locale="es"
                @change="fechaRespuestaPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col md="6">
            <v-textarea
              v-model="observaciones"
              label="Observaciones"
            ></v-textarea>
          </v-col>
          <v-col md="6">
            <v-textarea
              v-model="descripcion"
              label="Descripción de la modificación"
              :error-messages="descripcionErrors"
              @input="$v.descripcion.$touch()"
              @blur="$v.descripcion.$touch()"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="blue-grey darken-1"
          outlined
          :disabled="loading"
          text
          @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="blue-grey darken-1"
          dark
          :loading="loading"
          @click="guardarOficio()"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//Librerías
import axios from "axios";
import {Settings,DateTime} from 'luxon';
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, decimal } from "vuelidate/lib/validators";
//Componentes
import buscarEmisorEntidadComponent from "../widgets/buscarEmisorEntidad.vue";

//Ajustes de idioma para Luxon
Settings.defaultLocale = 'es';

export default {
  props: ["mostrar", "oficio", "esPadre"],
  mixins: [validationMixin],
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
    numeroErrors() {
      const errors = [];
      if (!this.$v.numero.$dirty) return errors;
      !this.$v.numero.required && errors.push("Campo requerido.");
      return errors;
    },
    asuntoErrors() {
      const errors = [];
      if (!this.$v.asunto.$dirty) return errors;
      !this.$v.asunto.required && errors.push("Campo requerido.");
      return errors;
    },
    fechaTexto() {
      return this.fecha ? DateTime.fromFormat(this.fecha, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
    },
    emisorResponsableErrors() {
      const errors = [];
      if (!this.$v.emisorResponsable.$dirty) return errors;
      !this.$v.emisorResponsable.required && errors.push("Campo requerido.");
      return errors;
    },
    emisorCargoErrors() {
      const errors = [];
      if (!this.$v.emisorCargo.$dirty) return errors;
      !this.$v.emisorCargo.required && errors.push("Campo requerido.");
      return errors;
    },
    destinatarioCargoErrors() {
      const errors = [];
      if (!this.$v.destinatarioCargo.$dirty) return errors;
      !this.$v.destinatarioCargo.required && errors.push("Campo requerido.");
      return errors;
    },
    documentosErrors() {
      const errors = [];
      if (!this.$v.documentos.$dirty) return errors;
      !this.$v.documentos.required && errors.push("Campo requerido.");
      !this.$v.documentos.decimal && errors.push("Debe ingresar un número");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcion.$dirty) return errors;
      !this.$v.descripcion.required && errors.push("Campo requerido.");
      return errors;
    },
    fechaRecepcionTexto() {
      return this.fechaRecepcion ? DateTime.fromFormat(this.fechaRecepcion, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
    },
    recepcion() {
      return this.fechaRecepcion + " " + this.horaRecepcion + ":00";
    },
    fechaRespuestaTexto() {
      return this.fechaRespuesta ? DateTime.fromFormat(this.fechaRespuesta, 'yyyy-MM-dd').toFormat("dd 'de' MMMM 'de' yyyy") : ''
    },
  },
  validations: {
    numero: { required },
    asunto: { required },
    emisorResponsable: { required },
    emisorCargo: { required },
    destinatarioCargo: { required },
    documentos: { required, decimal },
    descripcion: { required },
  },
  components: {
    buscarEmisorEntidadComponent,
  },
  data: () => ({
    loading: false,
    outlined: false,
    numero: null,
    asunto: null,
    fecha: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
    fechaPicker: false,
    statusList: [],
    statusSel: null,
    tipos: [],
    tipoSel: null,
    emisorEntidades: [],
    emisorEntidad: null,
    emisorResponsable: null,
    emisorCargo: null,
    dependencias: [],
    dependenciaSel: null,
    destinatarios: [],
    destinatarioSel: null,
    destinatarioCargo: null,
    documentos: 0,
    original: true,
    fechaRecepcion: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
    fechaRecepcionPicker: false,
    horaRecepcion: DateTime.now().setZone('America/Mazatlan').toFormat("T"),
    horaRecepcionPicker: false,
    recibioUsers: [],
    recibioUserSel: null,
    asignacion: null,
    requiereRespuesta: false,
    fechaRespuesta: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd"),
    fechaRespuestaPicker: false,
    observaciones: null,
    descripcion: null,
  }),
  watch: {
    requiereRespuesta(nueva) {
      if (!nueva) this.fechaRespuesta = null;
    },
  },
  created() {
    this.loading = true;
    axios
      .get(this.httpURL + "/oficios/datosGenerales", {
        headers: { token: this.sessionToken },
      })
      .then((res) => {
        // console.log(res.data);
        if (res.data.ok) {
          this.statusList = res.data.statusList;
          this.tipos = res.data.tipoDocumento;
          this.emisorEntidades = res.data.entidades;
          this.dependencias = res.data.dependencias;
          this.recibioUsers = res.data.receptores;
          this.cambioDependencia();
        } else {
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: res.data.mensaje,
          });
        }
        this.loading = false;
      })
      .catch((error) => {
        // console.log('Error: '+error);
        this.loading = false;
        this.$notify({
          group: "gral_notif",
          type: "error",
          duration: 1500,
          speed: 500,
          text: "Ocurrió un error al hacer la petición",
        });
      });
  },
  beforeMount() {
    this.numero = this.oficio.numero;
    this.asunto = this.oficio.asunto;
    this.fecha = DateTime.fromFormat(this.oficio.fecha, 'yyyy-MM-dd').toFormat("yyyy-MM-dd");
    this.statusSel = this.oficio.status;
    this.tipoSel = this.oficio.tipoDocumento;
    this.emisorEntidad = this.oficio.emisor.entidad._id;
    this.emisorResponsable = this.oficio.emisor.responsable;
    this.emisorCargo = this.oficio.emisor.cargo;
    this.dependenciaSel = this.oficio.destinatario.dependencia._id;
    this.destinatarioSel = this.oficio.destinatario.usuario._id;
    this.destinatarioCargo = this.oficio.destinatario.cargo;
    this.documentos = this.oficio.documentos;
    this.original = this.oficio.original;
    this.fechaRecepcion = DateTime.fromFormat(this.oficio.recepcion, 'yyyy-MM-dd T').toFormat("yyyy-MM-dd");
    this.horaRecepcion = DateTime.fromFormat(this.oficio.recepcion, 'yyyy-MM-dd T').toFormat("T");
    this.recibioUserSel = this.oficio.recibio._id;
    this.asignacion = this.oficio.asignacion._id;
    this.requiereRespuesta = this.oficio.fechaRespuesta == null ? false : true;
    this.fechaRespuesta = this.oficio.fechaRespuesta
      ? DateTime.fromFormat(this.oficio.fechaRespuesta, 'yyyy-MM-dd').toFormat("yyyy-MM-dd")
      : null;
    this.observaciones = this.oficio.observaciones;
  },
  methods: {
    cambioEntidad() {
      if (this.emisorEntidad != null) {
        let emisor = this.emisorEntidades.find((x) => x._id == this.emisorEntidad);
        this.emisorResponsable = emisor.responsable;
        this.emisorCargo = emisor.cargo;
        // console.log(dependencia);
      }
    },
    cambioDependencia() {
      if (this.dependenciaSel != null) {
      let dependencia = this.dependencias.find(
        (x) => x._id == this.dependenciaSel
      );
      //Se cargan los integrantes de la dependencia
      // console.log(dependencia);
      let destinatarios = [
        {
          _id: dependencia.titular.usuario._id,
          nombre:
            dependencia.titular.usuario.titulo +
            " " +
            dependencia.titular.usuario.nombreCompleto,
          puesto: dependencia.titular.puesto,
        },
      ];
      dependencia.integrantes.forEach((integrante) => {
        destinatarios.push({
          _id: integrante.usuario._id,
          nombre:
            integrante.usuario.titulo + " " + integrante.usuario.nombreCompleto,
          puesto: integrante.puesto,
        });
      });
      this.destinatarios = destinatarios;
      this.destinatarioSel = destinatarios[0]._id;
      this.destinatarioCargo = destinatarios[0].puesto;
      // console.log(dependencia);
      }
    },
    cambioDestinatario() {
      if (this.destinatarios != null) {
      let destinatario = this.destinatarios.find(
        (x) => x._id == this.destinatarioSel
      );
      this.destinatarioCargo = destinatario.puesto;
      }
    },
    guardarOficio() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        //Se preparan los datos para ser enviados
        let data = {
          numero: this.numero,
          asunto: this.asunto,
          fecha: this.fecha,
          status: this.statusSel,
          emisor: {
            entidad: this.emisorEntidad,
            responsable: this.emisorResponsable,
            cargo: this.emisorCargo,
          },
          destinatario: {
            dependencia: this.dependenciaSel,
            usuario: this.destinatarioSel,
            cargo: this.destinatarioCargo,
          },
          tipoDocumento: this.tipoSel,
          documentos: this.documentos,
          recepcion: this.fechaRecepcion ? (this.horaRecepcion? (this.fechaRecepcion+' '+this.horaRecepcion):this.fechaRecepcion) : null,
          original: this.original,
          recibio: this.recibioUserSel,
          captura: {
            fecha: DateTime.now().setZone('America/Mazatlan').toFormat("yyyy-MM-dd TT"),
            usuario: this.userId,
          },
          asignacion: this.asignacion,
          fechaRespuesta: this.requiereRespuesta ? this.fechaRespuesta : null,
          observaciones: this.observaciones,
        };

        // console.log(data);

        this.loading = true;
        axios
          .put(
            this.httpURL + "/oficios/entrante/" + this.oficio._id,
            { data, descripcion: this.descripcion, esPadre: this.esPadre },
            { headers: { token: this.sessionToken } }
          )
          .then((res) => {
            if (res.data.ok) {
              this.$notify({
                group: "gral_notif",
                type: "success",
                duration: 1500,
                speed: 500,
                text: res.data.mensaje,
              });
              this.$emit("oficioModificado");
              this.$emit("nuevoLog")
            } else {
              this.$notify({
                group: "gral_notif",
                type: "error",
                duration: 1500,
                speed: 500,
                text: res.data.mensaje,
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            // console.log('Error: '+error);
            this.loading = false;
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: "Ocurrió un error al hacer la petición",
            });
          });
      }
    },
    seleccionarEntidad(entidad){
      this.emisorEntidad = entidad._id;
      this.emisorResponsable = entidad.responsable;
      this.emisorCargo = entidad.cargo;
    },
    normalizarTexto(texto) {
        if (!texto) return ""; // Manejar valores nulos o vacíos
        return texto
            .normalize("NFD") // Divide caracteres acentuados
            .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
            .toLowerCase(); // Convierte a minúsculas
    },
    // Filtro personalizado para manejar búsqueda insensible a acentos
    customFilter(item, queryText, itemText) {
        // Normaliza el texto ingresado y el texto del ítem
        const textoBusquedaNormalizado = this.normalizarTexto(queryText);
        const textoItemNormalizado = this.normalizarTexto(itemText);

        // Realiza la comparación
        return textoItemNormalizado.includes(textoBusquedaNormalizado);
    },
  },
};
</script>